// Нейтральный бренд админки. Админ-панель — мульти-проектный сервис: одна
// инсталляция обслуживает много проектов (Trientes, TeslaPay, Bitbeon и т.д.).
// На страницах логина/логаута оператор ещё не выбрал проект, а в Logo/Footer
// есть fallback'и на случай отсутствия `currentProject` в дереве (auth pages
// вне MainLayout / ProjectProvider). Эти fallback'и должны быть проекто-
// независимыми — раньше там был хардкод «TeslaPay», создавал впечатление,
// что админка под один проект.
//
// Никакого env-override (REACT_APP_BRAND_*) — это вело бы к per-deployment
// брендингу одного проекта, что противоречит мультитенантности. На залогинен-
// ных страницах имя проекта берётся напрямую из `ProjectContext.currentProject`.
export const BRAND_NAME = 'Админ-панель';
